exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "head[data-v-7841599e]{width:100%;background:#1c1046;background:#18c5d9;top:0;z-index:8;left:0;position:fixed;display:grid;place-items:center;height:100vh;animation:close-data-v-7841599e .2s 4s 1 forwards}@keyframes close-data-v-7841599e{to{opacity:0;z-index:-1}}.circle[data-v-7841599e]{width:200px;height:200px;border-radius:200px;display:grid;place-items:center;background:#1c1046}.circ[data-v-7841599e]{width:180px;height:180px;border-radius:200px;border-top:90px solid #fff;background:#18c5d9;animation:rotate-data-v-7841599e 1.2s 0s infinite linear}@keyframes rotate-data-v-7841599e{to{transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7841599e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/preloader.vue
// module id = 61
// module chunks = 0